import { Pipe, PipeTransform } from '@angular/core';
import { RolesGeneral } from 'src/app/Interfaces/Admin/Roles.interface';

@Pipe({
    name: 'filterRole',
    standalone: false
})
export class FilterRolePipe implements PipeTransform {

  transform(value: RolesGeneral[], arg: string): RolesGeneral[] {

    if (arg === '' || arg.length < 2) return value;

    const ResultPost: RolesGeneral[] = [];

    for (const Role of value) {

      if (Role.Name.toLowerCase().includes(arg.toLowerCase())) {
        ResultPost.push(Role);
      }
    }

    return ResultPost;
  }

}